import { Badge, Button, Stack, Tooltip } from '@mui/material';

import { AccessGroupClientModel } from '@client-app-sdk';

import IntegrationsCell from './IntegrationsCell';
import { AnalyticsEvents } from '@common/utils/analytics/events';
import { Link } from 'react-router-dom';
import routes from '@routes';
import { SEARCH_PARAM } from '@MyAccess/utils/consts';

export interface AccessGroupSummaryProps {
  group: AccessGroupClientModel;
  detailsActive?: boolean;
  canSeeDetails?: boolean;
  initNewCreds?: boolean;
  isMyAccessEnabled?: boolean;
}

export default function AccessGroupSummary({
  group,
  detailsActive,
  canSeeDetails,
  initNewCreds,
  isMyAccessEnabled,
}: AccessGroupSummaryProps) {
  const hasNewCreds = (canSeeDetails && group.has_new_credentials) || initNewCreds;

  return (
    <Badge color="success" badgeContent="" variant="dot" invisible={!hasNewCreds} sx={{ width: '100%' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1} sx={{ width: '100%' }}>
        <IntegrationsCell integrations={[group.integration]} />
        {isMyAccessEnabled ? (
          <Stack direction="row" spacing={1}>
            <Button
              data-trigger={AnalyticsEvents.OpenRequestAccessDetailsClicked}
              size="small"
              variant={initNewCreds ? 'contained' : 'text'}
            >
              {detailsActive ? 'Hide' : 'View'} resources
            </Button>
            {canSeeDetails && (
              <Button
                size="small"
                component={Link}
                variant="outlined"
                to={`${routes.MyAccess.path}?${SEARCH_PARAM}=${group.integration.name}`}
                data-trigger={AnalyticsEvents.UseAccessInitiated}
              >
                Use access
              </Button>
            )}
          </Stack>
        ) : (
          <Tooltip title="New access credentials" arrow placement="top" open={hasNewCreds}>
            <Button
              data-trigger={AnalyticsEvents.OpenRequestAccessDetailsClicked}
              size="small"
              variant={initNewCreds ? 'contained' : 'text'}
            >
              {detailsActive ? 'Hide' : 'View'} access {canSeeDetails ? 'details' : 'units'}
            </Button>
          </Tooltip>
        )}
      </Stack>
    </Badge>
  );
}
